import { store } from '../store'
import { setErrorMessage } from '../actions'

const showErrorMessage = (message) => store.dispatch(setErrorMessage(message))

export default showErrorMessage
